import { LayoutState } from "./layoutProvider";

type UIActionType = { type: "UI - OpenClose Left Drawer" };

export const layoutReducer = (
  state: LayoutState,
  action: UIActionType,
): LayoutState => {
  switch (action.type) {
    case "UI - OpenClose Left Drawer":
      return {
        ...state,
        leftDrawer: {
          ...state.leftDrawer,
          isOpen: !state.leftDrawer.isOpen,
        },
      };

    default:
      return state;
  }
};
